<div class="uploader">
  <label for="file-uploader" class="custom-file-upload" fxLayoutAlign="center center"><i class="fa fa-cloud-upload" aria-hidden="true"></i> <span>{{nameBtn}}</span></label>
  <input id="file-uploader" type="file" onclick="this.value = null" (change)="fileChange($event)" multiple="false" placeholder="{{nameBtn}}" accept=".xlsx,.xls,.csv">
</div>
